var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (results, undefined) {
// iterate results
;(function(){
  var $$obj = results;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var result = $$obj[$index];

buf.push("<div class=\"results-list-item js-results-list-item\"><div class=\"garamond-results-list-item-cell\">" + (jade.escape(null == (jade_interp = result.get('name')) ? "" : jade_interp)) + "</div><div" + (jade.attr("data-id", result.id, true, true)) + " class=\"results-list-item-cell result-remove js-remove\"></div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var result = $$obj[$index];

buf.push("<div class=\"results-list-item js-results-list-item\"><div class=\"garamond-results-list-item-cell\">" + (jade.escape(null == (jade_interp = result.get('name')) ? "" : jade_interp)) + "</div><div" + (jade.attr("data-id", result.id, true, true)) + " class=\"results-list-item-cell result-remove js-remove\"></div></div>");
    }

  }
}).call(this);
}.call(this,"results" in locals_for_with?locals_for_with.results:typeof results!=="undefined"?results:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;